import api from './api'

export const handleEmailSubmit = async( data ) => {
  const result = await api.post( '/newsletter', data )
  return result
}
